import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01655a55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "section box_href" }
const _hoisted_9 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              lg: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_typography_title, { level: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 重磅发布！ ")
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_typography_title, { level: 5 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 《星汉未来Serverless行业白皮书》 ")
                  ]),
                  _: 1 /* STABLE */
                }),
                _createCommentVNode("<a-typography-paragraph>"),
                _createCommentVNode("</a-typography-paragraph>"),
                _createVNode(_component_a_button, {
                  type: "link",
                  class: "button_1",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.download($data.href.book)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查看完整白皮书 ")
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (v) => {
      return (_openBlock(), _createElementBlock("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (v.title)
            ? (_openBlock(), _createBlock(_component_a_typography_title, {
                key: 0,
                level: 1
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(v.title), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            : _createCommentVNode("v-if", true),
          (v.text)
            ? (_openBlock(), _createBlock(_component_a_typography_paragraph, { key: 1 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.text.split('<br>'), (t) => {
                    return (_openBlock(), _createElementBlock("p", null, _toDisplayString(t), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            : _createCommentVNode("v-if", true),
          (v.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                alt: "",
                src: v.image
              }, null, 8 /* PROPS */, _hoisted_5))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    }), 256 /* UNKEYED_FRAGMENT */)),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.download($data.href.book)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 查看完整报告 ")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_typography_title, { level: 2 }, {
          default: _withCtx(() => [
            _createTextVNode(" 更多白皮书 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_router_link, {
          class: "button_1",
          to: _ctx.$Enum.RouterEnum.BookCostOptimization
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 成本优化白皮书 ")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"]),
        _createVNode(_component_router_link, {
          class: "button_1",
          to: _ctx.$Enum.RouterEnum.BookDevOps
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 运维方案白皮书 ")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"]),
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_1",
          target: "_blank",
          href: $data.href.book_1
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 在离线混部白皮书 ")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}